import { Component } from '@angular/core';
import { LicServiceService } from '../../services/lic/lic-service.service';
import { AppointmentService } from '../../services/appointment/appointment.service';
import { AppointmentResponse } from '../../models/appointment.interface';
import { ROUTE_CONSTANTS } from '../../util/route.constants';
import { Router } from '@angular/router';
import { CVANotificationService } from '../../services/cva-notification/cva-notification.service';
import { CVA_CONSTANTS, StorageKeys } from '../../util/constants';
import { NotificationClassEnum } from '../../models/notification-class.enum';
import { LICAuthResponse } from '../../models/lic.interface';
import { PractitionerService } from '../../services/practitioner/practitioner.service';
import { environment } from '../../../environments/environment';

@Component({
  standalone: false,
  selector: 'cva-lic',
  templateUrl: './lic.component.html',

})
export class LicComponent {
  showMsg: boolean = false;
  errorMessage = '';
  cvaUI_url = environment.cvaUI_url;
  constructor(
    public readonly cvaNotificationService: CVANotificationService,
    public readonly router: Router,
    public readonly appointmentService: AppointmentService,
    public readonly licService: LicServiceService,
    private readonly practitionerService: PractitionerService
  ) {
    this.getLicAuth();
  }

  fetchAppointment(appointmentId: string): void {
    this.appointmentService.getAppointmentById(appointmentId).subscribe({
      next: (appointmentData: { response: AppointmentResponse }) => {
        const appointment = appointmentData.response;
        const viewMode = 'tab';
        this.router.navigate([ROUTE_CONSTANTS.CONSULTATION], {
          state: { appointment, viewMode },
        });
      },
    });
  }

  handleApiSuccess(
    data: LICAuthResponse,
    appointmentId: string
  ): void {
    console.log("handleApiSuccess ")
    localStorage.setItem('refreshToken', data.refreshToken);
    localStorage.setItem('idToken', data.id_token);
    localStorage.setItem('providerId', data.providerId);
    localStorage.setItem('firstLogin', data.firstLogin.toString());
    localStorage.setItem('authToken', data.auth_token);
    localStorage.setItem(StorageKeys.FACILITY_CODE, data.facilityId);
    this.practitionerService.getPractitionerByHpiId(data.providerId).subscribe(() => {
      this.fetchAppointment(appointmentId);
    });
  }

  handleApiError(errorResponse: {
    error: { message: string }
  }): void {
    console.log(errorResponse)
    this.errorMessage = errorResponse.error?.message || '';
    this.cvaNotificationService.showNotification(
      this.errorMessage || CVA_CONSTANTS.MESSAGE.LIC_AUTH_FAILED,
      NotificationClassEnum.ERROR
    );
  }

  getLicAuth() {
    console.log("getLicAuth block " + JSON.stringify(history?.state))
    if (history?.state?.licObject) {
      const body = {
        licToken: history.state.licObject.token,
        practitionerId: history.state.licObject.practitionerId.toLowerCase(),
      };

      this.licService.getLicAuthentication(body).subscribe({
        next: (data: LICAuthResponse) =>
          this.handleApiSuccess(data, history.state.licObject.appointmentId),
        error: (errorResponse) => this.handleApiError(errorResponse),
      });
    } else if (history?.state?.soapNotesSaved) {
      this.showMsg = true;
    } else {
      this.router.navigate([ROUTE_CONSTANTS.LOGIN]);
    }
  }
}
